export default __webpack_public_path__ + "static/color-emphasis-levels-status-light-e36e4057134689720d0be236e2d8088d9e249b8fcc4ad34d9f6ed634bc9b4a73.png";